<template>
  <div class="order-map">
    <leaflet-offline-map
      :id="mapId"
      :config="mapConfig"
      :markers="markers"
      :lines="lines"
      :polygons="polygons"
      :circles="circles"
      ref="leafletOfflineMap"
      v-if="valid"
    />
    <figure class="image is-64x64 ml-auto mr-auto" v-else style="display: flex; justify-content: center; align-items: center; min-height: 400px; width:100%;">

            <img src="@/assets/error_map_bad_coords.png" style="width:unset; margin:auto;" />

      <!-- <table>
        <tr>
          <td style="border:0px;">
            <img src="@/assets/error_map_bad_coords.png" style="width:unset; margin:auto;" />
          </td>
        </tr>
        <tr>
          <td style="border:0px;">Unable to preview map location</td>
        </tr>
      </table> -->

    </figure>
  </div>
</template>

<script>

import proj4 from '@/wrappers/proj4.js';

import LeafletOfflineMap from "@/components/LeafletOfflineMap";

import { OrderService } from "@/services/order.service";

export default {
  props: {
    mapId: {
      type: String
    },
    mapConfig: {
      type: Object,
      default: () => {}
    },
    order: {
      type: Object,
      required: true
    },
    operations: {
      type: Array,
      required: true
    }
  },
  components: {
    LeafletOfflineMap
  },
  mounted() {

    this.loadMapObjects();

    // console.log(this.order);

    // let latitudeStart = 5910762.590539;

    // let latitudeFinish = 5917125.409891;

    // const converted = proj4('ESPG:2193', 'WGS84', [5901149.042734, 1766232.853217]);

    // const converted = proj4('NZTM', 'GPS', [1766232.853217, 5901149.042734]);

    // let longitudeFinish = 1744965.626242;

    // console.log(this.order.loggedLat, this.order.loggedLng);

    // let latitudeStart = this.order.latitudeStart;

    // let latitudeFinish = this.order.latitudeFinish;

    // let loggedLat = this.order.loggedLat;

    // let loggedLng = this.order.loggedLng;

    // const converted = proj4('NZTM', 'GPS', [latitudeStart, 7345782.1221]);

    // console.log(converted);

    // const converted = proj4('NZTM', 'GPS', [latitudeStart, latitudeFinish]);

    // const converted = proj4('GPS', 'NZTM', [parseFloat(174.73452091669995), parseFloat(-36.74494256670006)]);

    // console.log(converted);


    // console.log(this.order);

    // if (this.order.loggedLat == null || this.order.loggedLng == null || this.order.loggedLat == 0 || this.order.loggedLng == 0 ) {

    //   if (this.order.loggedLat <= 90 && this.order.loggedLat >= -90 && this.order.loggedLng <= 180 && this.order.loggedLng >= -180) {

    //     console.log('error');

    //   }

    // }

    // Update order's logged_lat/lng
    if (!(this.order.loggedLat && this.order.loggedLng) && this.order.address) {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address: this.order.address }).then(response => {
        console.log(response)
        if (response.results && response.results.length) {
          const location = response.results[0].geometry.location;
          const lat = location.lat();
          const lng = location.lng();
          OrderService.updatePartial(this.order.id, {
            logged_lat: lat,
            logged_lng: lng,
          }).then(() => {
            this.order.loggedLat = lat;
            this.order.loggedLng = lng;
            this.$nextTick(() => {
              this.loadMapObjects();
            });
          });
        }
      });
    }

  },
  computed: {

    valid() {

      // New Validation

      // console.log(this.order);

      if (this.order.loggedLat == null || this.order.loggedLng == null || this.order.loggedLat == 0 || this.order.loggedLng == 0 ) {

        if (this.order.loggedLat <= 90 && this.order.loggedLat >= -90 && this.order.loggedLng <= 180 && this.order.loggedLng >= -180) {

          // console.log('error');

          return false;

        }

      }

      return true;

      return !!this.startPoint || !!this.finishPoint || !!this.jobLocation;

    },

    jobLocation() {

      if (this.order.loggedLat && this.order.loggedLng) {
        // loggedLat and loggedLng are already GPS
        let latLng = [this.order.loggedLat, this.order.loggedLng];
        return {
          latLng: latLng,
          popup: {
            content: "JOB LOCATION"
          },
          icon: {
            text: "X"
          }
        };
      } else {
        let operations = this.operations.filter(element => element.asset && element.asset.assetNodes && element.asset.assetNodes.length);
        if (operations.length) {
          let latLng = [operations[0].asset.assetNodes[0].latitude, operations[0].asset.assetNodes[0].longitude];
          return {
            latLng: latLng,
            popup: {
              content: "JOB LOCATION"
            },
            icon: {
              text: "X"
            }
          };
        }
      }

      return null;

    },

    startPoint() {
      if (this.order.latitudeStart && this.order.longitudeStart) {

        // Convert coordinate from NZTM to GPS
        const converted = this.nztmToWgs84(this.order.latitudeStart, this.order.longitudeStart);

        if (converted) {

          const { lat, lng } = converted;
          const latLng = [lat, lng];

          return {
            latLng,
            popup: {
              content: "START"
            },
            icon: {
              color: "#16A085",
              text: "S",
              style: "transform: rotate(-75deg)"
            }
          };
        }
      }

      return null;
    },

    finishPoint() {

      if (this.order.latitudeFinish && this.order.longitudeFinish) {

        // Convert coordinate from NZTM to GPS
        const converted = this.nztmToWgs84(this.order.latitudeFinish, this.order.longitudeFinish);

        if (converted) {

          const { lat, lng } = converted;
          const latLng = [lat, lng];

          return {
            latLng,
            popup: {
              content: "FINISH"
            },
            icon: {
              color: "#C0392B",
              text: "F",
              style: "transform: rotate(-15deg)"
            }
          };
        }
      }

      return null;
    },

    markers() {
      let markers = [];

      if (this.jobLocation) {
        markers.push(this.jobLocation);
      }

      if (this.startPoint) {
        markers.push(this.startPoint);
      }

      if (this.finishPoint) {
        markers.push(this.finishPoint);
      }

      return markers;
    },
    circles() {
      return this.operations.reduce((acc, operation) => {
        const asset = operation.asset;

        if (asset && asset.assetNodes && asset.assetNodes.length === 1) {
          let latLng = null;
          let options = {
            id: asset.id
          };

          asset.assetNodes.forEach(node => {
            latLng = [node.latitude, node.longitude];
          });

          acc.push({
            latLng,
            popup: {
              content: this.popupContent(operation)
            },
            options
          });
        }

        return acc;
      }, []);
    },
    lines() {
      return this.operations.reduce((acc, operation) => {
        const asset = operation.asset;

        if (asset && asset.assetNodes && asset.assetNodes.length === 2) {
          let latLngs = [];
          let options = {
            id: asset.id
          };

          asset.assetNodes.forEach(node => {
            latLngs.push([node.latitude, node.longitude]);
          });

          acc.push({
            latLngs,
            popup: {
              content: this.popupContent(operation)
            },
            options
          });
        }

        return acc;
      }, []);
    },
    polygons() {
      return this.operations.reduce((acc, operation) => {
        const asset = operation.asset;

        if (asset && asset.assetNodes && asset.assetNodes.length > 2) {
          let latLngs = [];
          let options = {
            id: asset.id
          };

          asset.assetNodes.forEach(node => {
            latLngs.push([node.latitude, node.longitude]);
          });

          acc.push({
            latLngs,
            popup: {
              content: this.popupContent(operation)
            },
            options
          });
        }

        return acc;
      }, []);
    }
  },
  watch: {
    order() {
      this.loadMapObjects();
    },
    operations() {
      this.loadMapObjects();
    }
  },
  methods: {
    loadMapObjects() {
      if (this.$refs.leafletOfflineMap) {
        this.$refs.leafletOfflineMap.clearLayer("markers");
        this.$refs.leafletOfflineMap.clearLayer("circles");
        this.$refs.leafletOfflineMap.clearLayer("lines");
        this.$refs.leafletOfflineMap.clearLayer("polygons");
        this.$nextTick(() => {
          this.$refs.leafletOfflineMap.loadMarkers();
          this.$refs.leafletOfflineMap.loadCircles();
          this.$refs.leafletOfflineMap.loadLines();
          this.$refs.leafletOfflineMap.loadPolygons();
          this.$refs.leafletOfflineMap.fitMainLayerBounds();
        });
      }
    },
    popupContent(operation) {
      let content = document.createElement("div");

      content.innerHTML = `<span>${operation.operationId || "PENDING"}</span>`;

      return content;
    },
    takeScreenshot() {
      return this.$refs.leafletOfflineMap.takeScreenshot();
    },
    nztmToWgs84(lat, lng) {

      if (lat && lng) {

        // Note, proj4 uses [x,y] which corresponds to [lng, lat]
        // (so longitude comes first which may seem a bit weird)
        try {
          // Our proj4 wrapper has aliases for NZTM and GPS defined
          const coordinates = proj4('NZTM', 'GPS', [parseFloat(lng), parseFloat(lat)]);
          const [longitude, latitude]  = coordinates;
          return { "lat": latitude, "lng": longitude };
        }
        catch (error) {
          window.console && console.log('[PROJ4 CONVERSION ERROR]');
          window.console && console.log(error);
        }
      }

      return null;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Order/OrderMap.vue